import type { RefObject } from "react";
import type { HistoricNarRecommendation } from "../../../../../../shared/api/services/historicNar/types";
import { LoaderMessage } from "../../../../../components/loaderMessage/loaderMessage";
import type { NarAgentGridOrgTab } from "../../narAgentGrid/hooks/useNarAgentGridOrgTabs";
import HistoricNarConfigTable from "./historicNarConfigTable";

interface HistoricNarConfigResultsPanelProps {
  tableRef: RefObject<HTMLDivElement>;
  rows: HistoricNarRecommendation[];
  visibleRows: HistoricNarRecommendation[];
  isLoading: boolean;
  hasFetched: boolean;
  clientOptions: NarAgentGridOrgTab[];
  onSearchTextChange: (value: string) => void;
  onRefresh: () => void;
}

/** Loading, initial-empty, and table states for the page. */
const HistoricNarConfigResultsPanel = ({
  tableRef,
  rows,
  visibleRows,
  isLoading,
  hasFetched,
  clientOptions,
  onSearchTextChange,
  onRefresh,
}: HistoricNarConfigResultsPanelProps) => (
  <div className="flex min-h-0 flex-1 flex-col">
    {isLoading ? (
      <div className="flex flex-1 items-center justify-center">
        <LoaderMessage message="Loading Historic NAR recommendations" />
      </div>
    ) : rows.length > 0 ? (
      <div className="flex-1 overflow-hidden">
        <HistoricNarConfigTable
          apiData={visibleRows}
          tableRef={tableRef}
          onSearchTextChange={onSearchTextChange}
          onRefresh={onRefresh}
          clientOptions={clientOptions}
        />
      </div>
    ) : (
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="text-center text-small text-primaryGray-3">
          {hasFetched
            ? "No historic NAR recommendations found."
            : "Loading historic NAR recommendations…"}
        </div>
      </div>
    )}
  </div>
);

export default HistoricNarConfigResultsPanel;
